import React from 'react';
import { PrematchContext } from '../../prematch/Prematch';
import { LiveContext } from '../Live';

function LiveMatchDropDown(props) {
    const liveContext = React.useContext(LiveContext);
    const prematchContext = React.useContext(PrematchContext);
    const context = liveContext || prematchContext;

    return (
        <>
            <div id="popup-events" className="popup">
                <div className="popup-content centered">
                    {props.tournaments && props.tournaments.map(function(tournament, i) {
                        const events = tournament.liveMatches ? [...tournament.liveMatches, ...tournament.events] : tournament.events;
                        return (
                            <React.Fragment key={tournament.uniqueId || i}>
                                <div className="manif-heading text-small">{tournament.descrizione}</div>
                                {events && events.map(function(match) {
                                    function handleClick(){
                                        props.toggleDropdown();
                                        context.openMatch(match);
                                    }
                                    const selected = context && context.match.id === match.id ? 'selected' : '';
                                    return <div key={match.uniqueId} className={`event-desc text-small ${selected}`} onClick={handleClick}>{match.team1} - {match.team2}</div>
                                })}
                            </React.Fragment>
                        )
                    })}
                </div>
            </div>
        </>
    );
}

export default LiveMatchDropDown;